import { LayoutPage } from '@/components/hoc';
import { useDocumentTitle } from '@/hooks';
import { BodyPage } from './components';
import { Text } from 'lucide-react';

const BioReviewPage = () => {

	useDocumentTitle({ title: 'Vérifications' });

	return (
		<LayoutPage
			header={{
				description: 'Voici les BIOs des utilisateurs qui ont été jugées problématiques.',
				title: 'Bio'
			}}
			breadcrumb={{ title: 'Bio' }}
			icon={Text}>
			<div className='pt-3 md:pt-5 flex flex-col space-y-3'>
				<BodyPage />
			</div>
		</LayoutPage>
	);

};

export default BioReviewPage;
